// src/pages/Project3DText.jsx
import { useEffect, useRef } from 'react';
import '../styles/ProjectPage.css'
import '../styles/Carousel.css'

import { initThreeJS } from '../scripts/threejs-3dtext.js';
import { initCarousel } from '../scripts/carousel.js';
import BackToTop from '../components/BackToTop';

export default function ProjectThreeText() {
    const canvasRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0);

        const carouselInstance = initCarousel();

        let cleanupThree = null;

        // Si le canvas est bien présent à l'écran, on lance Three.js
        if (canvasRef.current) {
            cleanupThree = initThreeJS(canvasRef.current);
        }

        // Nettoyage parfait quand on quitte la page
        return () => {
            if (cleanupThree) cleanupThree();
            if (carouselInstance) carouselInstance.destroy();
        };
    }, []);

    return (
        <div className="project-page">

            <main className="project-main">
                <div className="webgl-wrapper">
                    <canvas ref={canvasRef} className="webgl"></canvas>
                </div>

                <div className="project-content">
                    <h1>3D Text & Pancakes – Projet Three.js & Blender</h1>
                    <p className="project-desc">
                        Un hommage au film <em>Cosmic Princess Kaguya! </em>,
                        réalisé en 3D sur navigateur avec Three.js. J'ai modélisé le pancake 
                        sur <strong>Blender</strong>, puis je l'ai importée dans la scène WebGL. 
                        J'ai utilisé une HDRI pour la lumière et des matcaps pour le texte. <br />
                        Le projet a été réalisé dans le cadre de la formation "Three.js Journey" de Bruno Simon.
                    </p>

                    <div className="project-tech">
                        <h3>Techno</h3>
                        <ul>
                            <li>Three.js (WebGL)</li>
                            <li>Blender (Modélisation du pancake, voir ci-dessous)</li>
                            <li>Matcaps (Matériaux optimisés)</li>
                            <li>Environment Map (HDRI pour l'éclairage)</li>
                            <li>TextGeometry (Génération de texte 3D)</li>
                        </ul>
                    </div>
                </div>
            </main>

            <div className="carousel-section">
                <h3 className="carousel-title">Processus de création</h3>
                <div className="carousel-container">
                    <div className="carousel-track">
                        <div className="carousel-card">
                            <img src="/images/threejs-3dtext/screenshot1.png" alt="Blender 1" loading="lazy" decoding="async" />
                            <p className="carousel-caption">Modélisation du pancake sur Blender.</p>
                        </div>
                        <div className="carousel-card">
                            <img src="/images/threejs-3dtext/screenshot2.png" alt="Blender 2" loading="lazy" decoding="async" />
                            <p className="carousel-caption">Vertex Painting sous Blender.</p>
                        </div>
                        <div className="carousel-card">
                            <img src="/images/threejs-3dtext/screenshot3.png" alt="Blender 3" loading="lazy" decoding="async" />
                            <p className="carousel-caption">Les deux pancakes sont maintenant colorés, on
                            commence à voir les nuances et la composition.</p>
                        </div>
                        <div className="carousel-card">
                            <img src="/images/threejs-3dtext/screenshot4.png" alt="Blender 4" loading="lazy" decoding="async" />
                            <p className="carousel-caption">Vu en “Material Preview" pour vérifier textures,
                            shaders et matériaux.</p>
                        </div>
                        <div className="carousel-card">
                            <img src="/images/threejs-3dtext/screenshot5.png" alt="Blender 5" loading="lazy" decoding="async" />
                            <p className="carousel-caption">Vue en mode “Rendered" avec éclairage, matériaux et
                            ombres finales pour un résultat réaliste et
                            immersif.</p>
                        </div>
                    </div>
                    
                    <button className="carousel-btn carousel-btn-prev">‹</button>
                    <button className="carousel-btn carousel-btn-next">›</button>
                </div>
                <div className="carousel-dots"></div>
            </div>

            <BackToTop />
        </div>
    );
}